'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { classNames } from '@/lib/utils'

const items = [
  { href: '/dashboard', label: 'Vue d’ensemble' },
  { href: '/dashboard/subscription-requests', label: 'Demandes d’abonnement' },
  { href: '/dashboard/shops', label: 'Boutiques' },
  { href: '/dashboard/settings', label: 'Configuration SenKredi' },
  { href: '/admin/', label: 'Dashboard admin' },
]

export function Sidebar() {
  const pathname = usePathname()

  return (
    <aside className="sidebar">
      <div className="brand">
        <strong>SenKredi Backoffice</strong>
        <span>Support et administration</span>
      </div>

      <nav className="nav-list">
        {items.map((item) => {
          const isActive = pathname === item.href || pathname.startsWith(item.href + '/')
          return (
            <Link key={item.href} href={item.href} className={classNames('nav-link', isActive && 'active')}>
              {item.label}
            </Link>
          )
        })}
      </nav>
    </aside>
  )
}
